import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Text } from "../../components/Text";

export const FacebookMetaWindowCallback: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!window.opener) {
      navigate("/");
      return;
    }

    window.opener.postMessage(
      code
        ? { type: "FACEBOOK_META_CONNECT_SUCCESS", code, state }
        : { type: "FACEBOOK_META_CONNECT_CANCELLED", state },
      window.location.origin,
    );
    window.close();
  }, [navigate]);

  return <Text>{t("common.authenticating")}</Text>;
};
